import * as yup from "yup";

export const passwordRules = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()-_=+[\]{}|;:'",.<>/`~])[A-Za-z\d@$!%*?&#^()-_=+[\]{}|;:'",.<>/`~]{5,}$/;

export const authSchema = yup.object().shape({
  email: yup.string().email("Please enter a valid email").required("Required"),
  age: yup.number().positive().integer().required("Required"),
  password: yup
    .string()
    .min(5)
    .matches(passwordRules, { message: "Please create a stronger password" })
    .required("Required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Required"),
  institutionId: yup
    .string()
    .matches(/^[a-zA-Z0-9]+$/, "Institution ID must be alphanumeric.")
    .required("Institution ID is required."),
});

export const loginSchema = yup.object().shape({
  username: yup.string().required("Email or Username is required"),
  password: yup.string().required("Password is required"),
  institutionId: yup.string().required("Institution ID is required"),
});

export const createInstitutionSchema = yup.object().shape({
  name: yup
    .string()
    .min(3, "Name must be at least 3 characters")
    .max(100, "Name cannot exceed 100 characters")
    .required("Institution Name is required"),
  address: yup
    .string()
    .min(5, "Address must be at least 5 characters")
    .max(200, "Address cannot exceed 200 characters")
    .required("Institution Address is required"),
  email: yup
    .string()
    .email("Please enter a valid email")
    .max(100, "Email cannot exceed 100 characters")
    .required("Institution Email is required"),
  username: yup
    .string()
    .min(3, "Username must be at least 3 characters")
    .max(30, "Username cannot exceed 30 characters")
    .required("Username is required"),
  phone: yup.string().required("Phone Number is required"),
  type: yup.string().required("Institution Type is required"),
  rooms: yup.number().required("Licence Type is required"),
});

export const editInstitutionSchema = yup.object().shape({
  name: yup
    .string()
    .min(3, "Name must be at least 3 characters")
    .max(100, "Name cannot exceed 100 characters")
    .required("Institution Name is required"),
  address: yup
    .string()
    .min(5, "Address must be at least 5 characters")
    .max(200, "Address cannot exceed 200 characters")
    .required("Institution Address is required"),
  phone: yup.string().required("Phone Number is required"),
  type: yup.string().required("Institution Type is required"),
  rooms: yup.number().required("Licence Type is required"),
});

export const gatewaySchema = yup.object().shape({
  gatewayAddress: yup
    .string()
    .min(5, 'Gateway Address must be at least 5 characters')
    .max(255, 'Gateway Address must be 255 characters or less')
    .matches(/^[a-zA-Z0-9]+$/, 'Gateway Address must contain only alphanumeric characters')
    .required('Gateway Address is required'),
  igin: yup
    .string()
    .min(5, 'IGIN must be at least 5 characters')
    .max(50, 'IGIN must be 50 characters or less')
    .matches(/^[a-zA-Z0-9:.-]+$/, 'IGIN must contain only alphanumeric characters, colons, hyphens, or periods')
    .required('IGIN is required'),
  igvn: yup
    .string()
    .min(5, 'IGVN must be at least 5 characters')
    .max(50, 'IGVN must be 50 characters or less')
    .matches(/^[a-zA-Z0-9:.-]+$/, 'IGVN must contain only alphanumeric characters, colons, hyphens, or periods')
    .required('IGVN is required'),
});

export const sensorSchema = yup.object().shape({
  sensorAddress: yup
    .string()
    .min(5, 'Sensor Address must be at least 5 characters')
    .max(255, 'Sensor Address must be 255 characters or less')
    .matches(/^[a-zA-Z0-9]+$/, 'Sensor Address must contain only alphanumeric characters')
    .required('Sensor Address is required'),
  isin: yup
  .string()
  .min(5, 'ISIN must be at least 5 characters')
  .max(50, 'ISIN must be 50 characters or less')
  .matches(/^[a-zA-Z0-9:.-]+$/, 'ISIN must contain only alphanumeric characters, colons, hyphens, or periods')
  .required('ISIN is required'),
  isvn: yup
    .string()
    .min(5, 'ISVN must be at least 5 characters')
    .max(50, 'ISVN must be 50 characters or less')
    .matches(/^[a-zA-Z0-9:.-]+$/, 'ISVN must contain only alphanumeric characters, colons, hyphens, or periods')
    .required('ISVN is required'),
  });